import { render, staticRenderFns } from "./LeadTags.vue?vue&type=template&id=801cdefa&scoped=true"
import script from "./LeadTags.vue?vue&type=script&lang=ts"
export * from "./LeadTags.vue?vue&type=script&lang=ts"
import style0 from "./LeadTags.vue?vue&type=style&index=0&id=801cdefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801cdefa",
  null
  
)

export default component.exports